import { Box, BoxProps } from '@mantine/core'

import useStyles from './index.styles'

const FeatureCardInner = ({
  children,
  styles,
  classNames,
  className,
  ...rest
}: BoxProps) => {
  const { classes, cx } = useStyles(undefined, {
    name: 'FeatureCard__Inner',
    styles,
    classNames,
  })
  return (
    <Box className={cx('inner-section', className, classes.root)} {...rest}>
      {children}
    </Box>
  )
}

FeatureCardInner.displayName = 'FeatureCardInner'

export default FeatureCardInner
